import { getTotalLength } from "@/utils/helper.util";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { SearchFilterItem } from "@/types/SearchFilterItem.type";
import FilterSectionItem from "@/components/molecules/filter/FilterSectionItem";
import FormControl from "@/components/molecules/form/FormControl";
import FormWordSplitter from "@/components/molecules/form/FormWordSplitter";

const KeywordFilter = ({ name }: SearchFilterItem) => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  const keywords: string[] = watch(["keywords", "keywordsExclude"]);

  return (
    <FilterSectionItem
      id={name}
      title={t("search.filter.keywords.title")}
      filterCount={getTotalLength(keywords)}
      tooltip={t("search.filter.keywords.tooltip")}
    >
      <FormWordSplitter name="keywords" placeholder={t("search.filter.keywords.placeholder")} />

      <FormControl id="keywordsExclude" label={t("search.filter.keywords.exclude")}>
        <FormWordSplitter name="keywordsExclude" placeholder={t("search.filter.keywords.placeholder")} />
      </FormControl>
    </FilterSectionItem>
  );
};

export default KeywordFilter;
